export const links = [
  {
    text: "Create Your Site",
    url: "https://docs.roconpaas.io/home/create-site/",
  },
  {
    text: "Manage Your Site",
    url: "https://docs.roconpaas.io/home/manage-site/",
  },
  {
    text: "Staging Environment",
    url: "https://docs.roconpaas.io/home/staging-environment/",
  },
  {
    text: "Site Migration",
    url: "https://docs.roconpaas.io/home/migrate-your-site-2/",
  },
  {
    text: "File Explorer",
    url: "https://docs.roconpaas.io/home/user-role-priviliges/#user-role-priviliges",
  },
  {
    text: "How to add and point your domain",
    alterTexts: ["domain", "dns"],
    url: "https://docs.roconpaas.io/home/add-and-point-your-domain/",
  },
  {
    text: "How to enable SSL",
    alterTexts: ["Activate", "certificate"],
    url: "https://docs.roconpaas.io/home/add-and-point-your-domain/",
  },
  {
    text: "How to add or remove image to my site",
    url: "https://docs.roconpaas.io/home/add-delete-image-to-your-site/",
  },
  {
    text: "How to create a site with blueprint",
    url: "https://docs.roconpaas.io/home/create-a-blueprint-site/#how-to-create-a-site-with-blueprint",
  },
  {
    text: "How to create a Blueprint",
    url: "https://docs.roconpaas.io/home/getting-started-4/#how-to-create-a-blueprint",
  },
  {
    text: "Create Organization",
    url: "https://docs.roconpaas.io/home/create-organization/#build_organization",
  },
  {
    text: "Client Organization",
    url: "https://docs.roconpaas.io/home/create-organization/#create-a-client-organization",
  },
  {
    text: "Organization Dashboard",
    url: "https://docs.roconpaas.io/home/organization-dashboard/",
  },
  {
    text: "Manage Team Members",
    url: "https://docs.roconpaas.io/home/manage-team-members/",
  },
  {
    text: "How To Invite Users",
    url: "https://docs.roconpaas.io/home/how-to-invite-users/#how-to-invite-users",
  },
  {
    text: "How To Change Organization Name",
    url: "https://docs.roconpaas.io/home/edit-your-organiation-name/#change-your-organization-name",
  },
  {
    text: "How To Transfer Ownership",
    url: "https://docs.roconpaas.io/home/transfer-ownership/",
  },
  {
    text: "How to become a parent using handover",
    alterTexts: ["client"],
    url: "https://docs.roconpaas.io/home/handover/#how-to-become-a-parent-using-handover-",
  },
  {
    text: "How to Delete an Organization",
    url: "https://docs.roconpaas.io/home/delete-an-organization/#delete-your-organization",
  },
  {
    text: "User Role Priviliges",
    url: "https://docs.roconpaas.io/home/user-role-priviliges/#user-role-priviliges",
  },
  {
    text: "How to upgrade or downgrade a plan",
    url: "https://docs.roconpaas.io/home/upgrading-downgrading-a-plan/#upgradingdowngrading-a-plan-go-to-billing-portal",
  },
  {
    text: "How to buy additional sites",
    alterTexts: ["addons"],
    url: "https://docs.roconpaas.io/home/buying-additional-sites/#buying-additional-sites",
  },
  {
    text: "How to add a payment method",
    url: "https://docs.roconpaas.io/home/modifying-your-payment-method/#adding-a-payment-method",
  },
  {
    text: "How to remove a payment method",
    url: "https://docs.roconpaas.io/home/modifying-your-payment-method/#deleting-a-payment-method",
  },
  {
    text: "How to make a payment method default",
    url: "https://docs.roconpaas.io/home/modifying-your-payment-method/#making-a-payment-method-default",
  },
  {
    text: "How to raise a ticket",
    url: "https://docs.roconpaas.io/home/how-to-raise-a-ticket/",
  },
];
